<template>
  <div class="container checkout">
    <oie-checkout-header></oie-checkout-header>

    <div class="checkout__page-content">
      <h1 class="checkout__page-header">
        {{ title }}
      </h1>

      <div class="checkout__page-text" v-html="body">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    body: { type: String, required: true },
    url: { type: String, required: true }
  },
  mounted() {
    if(this.url) {
      window.location.replace(this.url)
    }
  }
}
</script>

<style lang="scss">

</style>
